import { memo } from 'react';

import { GameStationCell, GameStationCellProps } from '../GameStationCell';
import {
  AssistedStationCell,
  AssistedStationCellProps,
} from '../AssistedStationCell';
import {
  ChallengeStationCell,
  ChallengeStationCellProps,
} from '../ChallengeStationCell';
import { GoalStationCell, GoalStationCellProps } from '../GoalStationCell';
import {
  RewardStationCell,
  RewardStationCellProps,
} from '../RewardStationCell';
import { StartStationCell, StartStationCellProps } from '../StartStationCell';
import { EmptyStationCell, EmptyStationCellProps } from '../EmptyStationCell';

export enum StationCellType {
  Start = 'start',
  Game = 'game',
  Assisted = 'assisted',
  Challenge = 'challenge',
  Reward = 'reward',
  Goal = 'goal',
  Empty = 'empty',
}

export type StationCellProps =
  | { type: StationCellType.Start; props: StartStationCellProps }
  | { type: StationCellType.Game; props: GameStationCellProps }
  | { type: StationCellType.Assisted; props: AssistedStationCellProps }
  | { type: StationCellType.Challenge; props: ChallengeStationCellProps }
  | { type: StationCellType.Reward; props: RewardStationCellProps }
  | { type: StationCellType.Goal; props: GoalStationCellProps }
  | { type: StationCellType.Empty; props: EmptyStationCellProps };

export const StationCell = memo((props: StationCellProps) => {
  if (props.type === StationCellType.Start) {
    return <StartStationCell {...props.props} />;
  }
  if (props.type === StationCellType.Game) {
    return <GameStationCell {...props.props} />;
  }
  if (props.type === StationCellType.Assisted) {
    return <AssistedStationCell {...props.props} />;
  }
  if (props.type === StationCellType.Challenge) {
    return <ChallengeStationCell {...props.props} />;
  }
  if (props.type === StationCellType.Reward) {
    return <RewardStationCell {...props.props} />;
  }
  if (props.type === StationCellType.Goal) {
    return <GoalStationCell {...props.props} />;
  }
  if (props.type === StationCellType.Empty) {
    return <EmptyStationCell {...props.props} />;
  }
  return null;
});
